export default function Contact() {
    return (
      <div className="page-content">
        <h1>Contact Us</h1>
        <p>Email: info@organicgreenshub.com</p>
        <p>Phone: +94 712 156 786</p>
        <p>Address: 1328/1c, 10th Lane, Bogahawaththa Road, Hyderabad, India</p>
      </div>
    );
  }
  